<template>
    <div>
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">智慧水务</div>
          <el-form
            class="zj-search-form"
            ref="form"
            :model="form"
            :label-width="labelWidth"
          >
            <!-- <el-form-item label="用户名" prop="UserName">
              <el-input v-model="UserName" placeholder="请输入用户名"></el-input>
            </el-form-item> -->
            <el-form-item label="开始时间">
              <el-date-picker
                placeholder="选择日期"
                v-model="BeginTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                :clearable="true"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker
                placeholder="选择日期"
                v-model="EndTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                :clearable="true"
              ></el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="模块名" prop="ModuleName">
              <el-input
                v-model="ModuleName"
                placeholder="请输入模块名"
              ></el-input>
            </el-form-item>
            <el-form-item label="页面名" prop="PageName">
              <el-input v-model="PageName" placeholder="请输入页面名"></el-input>
            </el-form-item> -->
            <el-form-item label class="right">
              <el-button @click="onSearch">查 询</el-button>
              <el-button @click="onCancel">清 理</el-button>
            </el-form-item>
          </el-form>
          <el-divider></el-divider>
        </zj-layout-header>
        <zj-layout-main>
          <div class="zj-layout-main-content bgcolor scrollable">
            <div class="zj-table-container">
              <div class="info">缴费总金额(元)：{{ amount }}，缴费数量：{{ allAcount }}</div>
              <el-table
                :data="tableData"
                ref="multipleTable"
                border
                style="width: 100%"
                fixed
              >
                <el-table-column
                  type="index"
                  label="序号"
                  width="80"
                  align="center"
                ></el-table-column>
                <el-table-column prop="userName" label="缴费用户"  min-width="180"></el-table-column>
                <el-table-column prop="userId" label="用户ID"  min-width="100"></el-table-column>
                <el-table-column
                  prop="paymentTypeTranslated"
                  label="缴费类型"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  prop="userType"
                  label="用户类型"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  prop="userAddress"
                  label="用户地址"
                  min-width="180"
                ></el-table-column>
                <el-table-column
                  prop="paymentTime"
                  label="缴费时间"
                  :formatter="formatDate"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  prop="amount"
                  label="金额"
                  width="160"
                ></el-table-column>
                <!-- <el-table-column label="操作" width="120" align="center">
                  <template slot-scope="scope">
                    <template>
                      <el-button
                        @click="queryDetail(scope.$index, scope.row)"
                        type="text"
                        size="small"
                        >查看</el-button
                      >
                    </template>
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
          </div>
        </zj-layout-main>
        <zj-layout-footer>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="total"
          ></el-pagination>
        </zj-layout-footer>
      </zj-layout-container>
    </div>
  </template>
  
  <script>
  // import { paymentCountStat,paymentAmountStat} from "@/api/src/smartWaterApi.js"
  import { getWaterPaymentList } from "@/api/src/data2-server.js"
  export default {
    name: "smartWaterManageList",
    controller: "UI",
    action: "smartWaterManageList",
    data() {
      return {
        currentPage: 1,
        pageSize: 20,
        total: 0,
        tableData: [],
        UserName: "",
        BeginTime: new Date().format("yyyy-MM-dd 0:00"),
        EndTime: new Date().format("yyyy-MM-dd 23:59"),
        ModuleName: "",
        PageName: "",
        amount:0,
        allAcount:0
      };
    },
    mounted: function() {
      this.search();
      // this.logInfo.ActionName = "操作日志查询";
      // this.logInfo.LogMessage = "操作日志查询";
      // this.logInfo.ModuleName = "日志管理";
      // this.logInfo.PageName = "操作日志列表";
     // this.addOperationLog();
      // this.getAmount();
      // this.getAllNum();
    },
    filters: {
      formatDatSingle(data) {
        if (data == null || data == "0001-01-01T00:00:00") {
          return null;
        }
  
        return new Date(data).format("yyyy-MM-dd hh:mm:ss");
      },
    },
    methods: {
      search() {
        let params={
          begin: this.BeginTime,
          end: this.EndTime,
          pageNum:this.currentPage,
          pageSize:this.pageSize
        }
        getWaterPaymentList(params).then(res=>{
           if(res.code==200){
             this.tableData = res.rows;
             this.total = res.total;
             this.allAcount = res.total;
             this.amount = res.totalNum;
           }else{
            this.errmsg(res.msg?res.msg : "服务异常，请联系管理员！");
           }
        })
      },
      //查看
      queryDetail(index, row) {
        this.$router.push({
          path: "/plugin/systemLog/ui/OperationLogDetail",
          query: { InfoId: row.LogId },
        });
      },
      // 点击查询按钮
      onSearch() {
        if (new Date(this.EndTime) < new Date(this.BeginTime)) {
          this.$message.error("开始时间不能大于结束时间");
          return;
        }
        this.currentPage = 1;
        this.search();
        // this.getAmount();
        // this.getAllNum();
      },
      clearsearch() {
        this.UserName = "";
        this.BeginTime = new Date().format("yyyy-MM-dd 0:00");
        this.EndTime = new Date().format("yyyy-MM-dd 23:59");
        this.ModuleName = "";
        this.PageName = "";
      },
      // getAmount(){
      //   let params={
      //     "startDate":this.BeginTime,
      //     "endDate":this.EndTime
      //   }
      //   paymentAmountStat(params).then(res=>{
      //     if(res.code==200){
      //       res.data.forEach(item=>{
      //        this.amount += item.money
      //       })
      //     }
      //   })
      // },
      // getAllNum(){
      //   let params={
      //     "startDate":this.BeginTime,
      //     "endDate":this.EndTime
      //   }
      //   // amount:0,
      //   // allAcount:0
      //   paymentCountStat(params).then(res=>{
      //     if(res.code==200){
      //       res.data.forEach(item=>{
      //        this.allAcount += item.num
      //       })
      //     }
      //   })
      // },
      // 点击取消按钮
      onCancel() {
        this.clearsearch();
        this.search();
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.search();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.search();
      },
      //日期列表展示格式
      formatDate(row, column) {
        // 获取单元格数据
        let data = row[column.property];
        if (data == null || data == "0001-01-01T00:00:00") {
          return null;
        }
        return new Date(data).format("yyyy-MM-dd hh:mm:ss");
      },
    },
  };
  </script>
  <style scoped>
  .info{
     font-size: 16px;
     height: 40px;
     line-height: 40px;
     padding-left: 15px;
  }
 </style>
  